import { render, staticRenderFns } from "./tuktuk888.vue?vue&type=template&id=0ae1a4fe"
import script from "./tuktuk888.vue?vue&type=script&lang=js"
export * from "./tuktuk888.vue?vue&type=script&lang=js"
import style0 from "./tuktuk888.vue?vue&type=style&index=0&id=0ae1a4fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@4.1.0_webpack@4.47.0__css-load_5de41679bf635eff2aa331ed73b7ea87/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports